import React from "react";

export const STEPS = [
  { number: 1, label: "Proposal Details" },
  { number: 2, label: "Personal info" },
  { number: 3, label: "Identification" },
  { number: 4, label: "Employment" },
  { number: 5, label: "Insurance History" },
  { number: 6, label: "Nominee" },
  { number: 7, label: "Health Details" },
  { number: 8, label: "Declaration" },
  { number: 9, label: "Review & Submit" },
];

interface ProposalStepperProps {
  currentStep: number;
  onStepClick?: (step: number) => void;
}

const ProposalStepper: React.FC<ProposalStepperProps> = ({
  currentStep,
  onStepClick,
}) => {
  const isStepActive = (stepNumber: number) => stepNumber === currentStep;
  const isStepCompleted = (stepNumber: number) => stepNumber < currentStep;
  const isStepAccessible = (stepNumber: number) => stepNumber <= currentStep;

  return (
    <div className="proposal-stepper">
      <div className="stepper-container">
        {/* Background Gray Line */}
        <div className="stepper-line" />

        {/* Steps */}
        {STEPS.map((step, index) => {
          const isActive = isStepActive(step.number);
          const isCompleted = isStepCompleted(step.number);
          const isAccessible = isStepAccessible(step.number);
          const isLast = index === STEPS.length - 1;

          return (
            <div
              key={step.number}
              className={`step-item ${!isAccessible ? "disabled" : ""}`}
              onClick={() => isAccessible && onStepClick && onStepClick(step.number)}
            >
              {/* Step Circle */}
              <div
                className={`step-circle ${
                  isActive ? "active" : isCompleted ? "completed" : "inactive"
                }`}
              >
                {isCompleted ? (
                  <i className="ri-check-line" style={{ fontSize: "1.2rem" }}></i>
                ) : (
                  step.number
                )}

                {/* Teal line and dot extending from active circle */}
                {isActive && !isLast && (
                  <>
                    <div className="step-progress-line" />
                    <div className="step-progress-dot" />
                  </>
                )}
              </div>

              {/* Step Label */}
              <div className={`step-label ${isActive ? "active" : "inactive"}`}>
                {step.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProposalStepper;
